module.exports = __webpack_public_path__ + "static/media/salesforce_logo.93958c09.png";